import imageCompression from "browser-image-compression";

export const compressImage = async (file, maxSizeMB = 2) => {
  try {
    if (!file) return null;

    if (file.size <= maxSizeMB * 1024 * 1024) {
      return file;
    }

    const options = {
      maxSizeMB,
      maxWidthOrHeight: 1920,
      initialQuality: 0.6,
      useWebWorker: true,
    };

    const compressedBlob = await imageCompression(file, options);

    if (!compressedBlob || compressedBlob.size === 0) {
      return file;
    }

    // Convert Blob to File
    return new File([compressedBlob], file.name, {
      type: compressedBlob.type || file.type,
      lastModified: Date.now(),
    });

  } catch (err) {
    console.error("Image compression failed:", err);
    return file;
  }
};
